import { render, staticRenderFns } from "./icon5.vue?vue&type=template&id=0d8ff9ee&scoped=true&"
import script from "./icon5.vue?vue&type=script&lang=js&"
export * from "./icon5.vue?vue&type=script&lang=js&"
import style0 from "./icon5.vue?vue&type=style&index=0&id=0d8ff9ee&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ff9ee",
  null
  
)

export default component.exports